import { useState, useEffect } from "react";

// STYLES
import * as Style from "./DiscountDetailsStyle";

// LIBRARIES
import { Dayjs } from "dayjs";

// MISC
import { usersListMockup } from "mocks/UsersListMockup";
import { ButtonTypes } from "models/GeneralTypes/generalTypes";

// ASSETS
import SearchIcon from "assets/Icons/SearchIcon.svg";

// REDUX

// COMPONENTS
import UserProfile from "../../components/UserProfile/UserProfile";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import DateInputAtom from "components/Atoms/DateInputAtom/DateInputAtom";
import TextEditor from "components/TextEditor/TextEditor";

const DiscountDetails = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  // CONSTANTS USING HOOKS

  const [startValue, setStartValue] = useState<Dayjs | null>(null);
  const [endValue, setEndValue] = useState<Dayjs | null>(null);
  const [inputValue, setInputValue] = useState<string>("");
  const [usersList, setUsersList] = useState<any[]>(usersListMockup);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    if (inputValue.length > 0) {
      let filteredUsers = usersListMockup.filter((user) =>
        user.firstName.toLowerCase().includes(inputValue.toLowerCase())
      );
      setUsersList(filteredUsers);
    } else {
      setUsersList(usersListMockup);
    }
  }, [inputValue]);
  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleRenderUser = (user) => {
    return <UserProfile user={user} handleSelect={handleSelectPerson} />;
  };

  const handleSelectPerson = (selectedUser) => {
    let usersListCopy = usersList.map((user) => {
      if (user.id === selectedUser.id) {
        user.isSelected = !user.isSelected;
      }

      return user;
    });
    setUsersList(usersListCopy);
  };

  const handleSelectAllPersons = () => {
    let usersListCopy = usersList.map((user) => {
      user.isSelected = true;

      return user;
    });
    setUsersList(usersListCopy);
  };
  const handleDeselectAllPersons = () => {
    let usersListCopy = usersList.map((user) => {
      user.isSelected = false;

      return user;
    });
    setUsersList(usersListCopy);
    setInputValue("");
  };

  return (
    <Style.Container>
      <Style.Title>Adauga discount</Style.Title>
      <Style.DetailsContainer>
        <Style.CardDetailsContainer>
          <Style.InputsContainer>
            <Style.InputContainer>
              <InputAtom label="Cod discount" placeholder="COD DISCOUNT" />
            </Style.InputContainer>
            <Style.DatesInputContainer>
              <Style.DateInputContainer>
                <DateInputAtom
                  label="De la"
                  value={startValue}
                  setValue={setStartValue}
                />
              </Style.DateInputContainer>
              <Style.DateInputContainer>
                <DateInputAtom
                  label="Pana la"
                  value={endValue}
                  setValue={setEndValue}
                />
              </Style.DateInputContainer>
            </Style.DatesInputContainer>
          </Style.InputsContainer>
          <Style.DescriptionContainer>
            {/* <InputAtom
              multiline
              height="360px"
              label="Descriere"
              placeholder="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
            /> */}
            <TextEditor label="Descriere" height={363} />
          </Style.DescriptionContainer>
        </Style.CardDetailsContainer>
        <Style.SearchingContainer>
          <Style.SearchingBarContainer>
            <Style.LeftContent>
              <Style.InputContainer>
                <InputAtom
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                  label="Cauta"
                  placeholder="Cauta..."
                />
              </Style.InputContainer>
              <Style.IconContainer
                onClick={() => handleSelectAllPersons()}
                src={SearchIcon}
              />
            </Style.LeftContent>
            <Style.SearchButtonContainer>
              <ButtonAtom
                onClick={() => handleDeselectAllPersons()}
                text="Clear Filters"
                type={ButtonTypes.MAIN_BUTTON}
              />
            </Style.SearchButtonContainer>
          </Style.SearchingBarContainer>
          <Style.UsersWrapper>
            <Style.UsersContent>
              {usersList.map((user) => handleRenderUser(user))}
            </Style.UsersContent>
          </Style.UsersWrapper>
        </Style.SearchingContainer>
      </Style.DetailsContainer>
      <Style.ButtonContainer>
        <ButtonAtom text="Vizualizeaza" type={ButtonTypes.MAIN_BUTTON} />
      </Style.ButtonContainer>
    </Style.Container>
  );
};

export default DiscountDetails;
